// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

const isScheduleEntry = objectOf({
  date: string,
  volume: number,
});

export const isEmailIpWarmingAppGroupIdScheduleResult = objectOf({
  schedule: arrayOf(isScheduleEntry),
});
